<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Chassis Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (chassisStyleSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Chassis Style:</label>
              <select class="halfWidthInputField" #chassisStyleInput
                [class.invalidConfigurationSelection]="isInvalidSelection(chassisStyleSelection.Name)"
                (change)="selectionChanged(chassisStyleSelection, chassisStyleInput.value)"
                [value]="chassisStyleSelection.Value.toString()">
                @for (allowable of chassisStyleSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="chassisStyleSelection.Value && chassisStyleSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (shippingSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Shipping:</label>
              <select class="halfWidthInputField" #shippingInput
                [class.invalidConfigurationSelection]="isInvalidSelection(shippingSelection.Name)"
                (change)="selectionChanged(shippingSelection, shippingInput.value)"
                [value]="shippingSelection.Value.toString()">
                @for (allowable of shippingSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="shippingSelection.Value && shippingSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (voltageSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Voltage:</label>
              <select class="halfWidthInputField" #voltageInput
                [class.invalidConfigurationSelection]="isInvalidSelection(voltageSelection.Name)"
                (change)="selectionChanged(voltageSelection, voltageInput.value)"
                [value]="voltageSelection.Value.toString()">
                @for (allowable of voltageSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="voltageSelection.Value && voltageSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (controlsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Controls:</label>
              <select class="halfWidthInputField" #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (autoFlowRegulatorSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Auto Flow Regulator:</label>
              <select class="halfWidthInputField" #autoFlowRegulatorInput
                [class.invalidConfigurationSelection]="isInvalidSelection(autoFlowRegulatorSelection.Name)"
                (change)="selectionChanged(autoFlowRegulatorSelection, autoFlowRegulatorInput.value)"
                [value]="autoFlowRegulatorSelection.Value.toString()">
                @for (allowable of autoFlowRegulatorSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="autoFlowRegulatorSelection.Value && autoFlowRegulatorSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (waterCircuitSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Water Circuit:</label>
              <select class="halfWidthInputField" #waterCircuitInput
                [class.invalidConfigurationSelection]="isInvalidSelection(waterCircuitSelection.Name)"
                (change)="selectionChanged(waterCircuitSelection, waterCircuitInput.value)"
                [value]="waterCircuitSelection.Value.toString()">
                @for (allowable of waterCircuitSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="waterCircuitSelection.Value && waterCircuitSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (heatExchangerOptionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Heat Exchanger Options:</label>
              <select class="halfWidthInputField" #heatExchangerInput
                [class.invalidConfigurationSelection]="isInvalidSelection(heatExchangerOptionsSelection.Name)"
                (change)="selectionChanged(heatExchangerOptionsSelection, heatExchangerInput.value)"
                [value]="heatExchangerOptionsSelection.Value.toString()">
                @for (allowable of heatExchangerOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="heatExchangerOptionsSelection.Value && heatExchangerOptionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (chassisInsulationOptionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Chassis Insulation Options:</label>
              <select class="halfWidthInputField" #chassisInsulationOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(chassisInsulationOptionsSelection.Name)"
                (change)="selectionChanged(chassisInsulationOptionsSelection, chassisInsulationOptionsInput.value)"
                [value]="chassisInsulationOptionsSelection.Value.toString()">
                @for (allowable of chassisInsulationOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="chassisInsulationOptionsSelection.Value && chassisInsulationOptionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (blowerMotorSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Blower Motor:</label>
              <select class="halfWidthInputField" #blowerMotorInput
                [class.invalidConfigurationSelection]="isInvalidSelection(blowerMotorSelection.Name)"
                (change)="selectionChanged(blowerMotorSelection, blowerMotorInput.value)"
                [value]="blowerMotorSelection.Value.toString()">
                @for (allowable of blowerMotorSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="blowerMotorSelection.Value && blowerMotorSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
